module.exports = "https://www.gc-pro.gnp.com.mx/d41d5f4c155da913f47725fa0d0923f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons-gnp/linea-GNP.svg
// module id = 8138
// module chunks = 0